import React, { useState } from "react";
import { fixedPermissions, permissionsList } from "../../access/AllPageForRoles";

const RolesPage = () => {
  const [roles, setRoles] = useState([
    {
      name: "Developer",
      permissions: ["Read Code", "Write Code", "Deploy Code"],
    },
    {
      name: "ADMIN",
      permissions: ["Manage Users", "Manage Roles", "View Reports"],
    },
    {
      name: "TEAM LEADER",
      permissions: ["Assign Tasks", "Approve Leaves"],
    },
  ]);

  const [editIndex, setEditIndex] = useState(null);
  const [editRoleData, setEditRoleData] = useState({});
  const [newRole, setNewRole] = useState({ name: "", permissions: [] });

  const handleEdit = (index) => {
    setEditIndex(index);
    setEditRoleData({ ...roles[index] });
  };

  const handleSaveEdit = (index) => {
    const updatedRoles = [...roles];
    updatedRoles[index] = editRoleData;
    setRoles(updatedRoles);
    setEditIndex(null);
  };

  const handleDelete = (index) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this role?");
    if (confirmDelete) {
      setRoles(roles.filter((_, i) => i !== index));
    }
  };

  const handlePermissionChange = (permission, roleData, setRoleData) => {
    const updatedPermissions = roleData.permissions.includes(permission)
      ? roleData.permissions.filter((perm) => perm !== permission)
      : [...roleData.permissions, permission];
    setRoleData({ ...roleData, permissions: updatedPermissions });
  };

  const handleAddRole = () => {
    if (!newRole.name.trim()) {
      alert("Role name cannot be empty");
      return;
    }
    if (newRole.permissions.length === 0) {
      alert("Please select at least one permission");
      return;
    }
    setRoles([...roles, newRole]);
    setNewRole({ name: "", permissions: [] });
  };

  return (
    <div className="p-4 max-w-7xl mx-auto bg-black text-white min-h-screen">
      <h3>Add New Role</h3>
      {/* Add Role Section */}
      <div className="mb-8 p-4 bg-gray-800 rounded-lg">
        <div className="flex items-center mb-4 space-x-4">
          <input
            type="text"
            placeholder="Enter role name"
            value={newRole.name}
            onChange={(e) => setNewRole({ ...newRole, name: e.target.value })}
            className="w-1/3 px-4 py-2 rounded bg-gray-700 text-white border border-gray-600 focus:outline-none"
          />
          <div className="flex flex-wrap gap-4 w-2/3">
            {permissionsList.map((permission) => (
              <div key={permission} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={newRole.permissions.includes(permission)}
                  onChange={() =>
                    handlePermissionChange(permission, newRole, setNewRole)
                  }
                  className="form-checkbox text-green-500"
                />
                <label>{permission}</label>
              </div>
            ))}
          </div>
        </div>
        <button
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          onClick={handleAddRole}
        >
          Add Role
        </button>
      </div>

      {/* Role List Table */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-600">
          <thead>
            <tr className="bg-gray-800">
              <th className="border border-gray-600 px-4 py-2 text-left">Role Name</th>
              <th className="border border-gray-600 px-4 py-2 text-left">Permissions</th>
              <th className="border border-gray-600 px-4 py-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {roles.map((role, index) => (
              <tr key={index} className="hover:bg-gray-700">
                <td className="border border-gray-600 px-4 py-2 w-1/4">
                  {editIndex === index ? (
                    <input
                      type="text"
                      value={editRoleData.name}
                      onChange={(e) =>
                        setEditRoleData({ ...editRoleData, name: e.target.value })
                      }
                      className="w-full px-2 py-1 rounded bg-gray-800 text-white border border-gray-600 focus:outline-none"
                    />
                  ) : (
                    role.name
                  )}
                </td>
                <td className="border border-gray-600 px-4 py-2">
                  {editIndex === index ? (
                    <div className="flex flex-wrap gap-4">
                      {[
                        "Read Code",
                        "Write Code",
                        "Deploy Code",
                        "Manage Users",
                        "Manage Roles",
                        "View Reports",
                        "Assign Tasks",
                        "Approve Leaves",
                      ].map((permission) => (
                        <div key={permission} className="flex items-center space-x-2">
                          <input
                            type="checkbox"
                            checked={editRoleData.permissions.includes(permission)}
                            onChange={() =>
                              handlePermissionChange(permission, editRoleData, setEditRoleData)
                            }
                            className="form-checkbox text-green-500"
                          />
                          <label>{permission}</label>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="flex flex-wrap gap-4">
                      {role.permissions.map((permission) => (
                        <div key={permission} className="flex items-center space-x-2">
                          <span className="text-green-500">✅</span>
                          <span>{permission}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </td>
                <td className="border border-gray-600 px-4 py-2 text-center flex">
                  {editIndex === index ? (
                    <button
                      className="bg-green-500 text-white px-2 py-1 rounded m-1 hover:bg-green-600"
                      onClick={() => handleSaveEdit(index)}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="bg-blue-500 text-white px-2 py-1 rounded m-1 hover:bg-blue-600"
                      onClick={() => handleEdit(index)}
                    >
                      Edit
                    </button>
                  )}
                  <button
                    className="bg-red-500 text-white px-2 py-1 rounded m-1 hover:bg-red-600"
                    onClick={() => handleDelete(index)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RolesPage;
